// src/components/atoms/FormDateField.jsx
import React from "react";
import TextField from "@mui/material/TextField";

/**
 * Date input atom. Wraps MUI TextField type="date" with consistent styling.
 */
export default function FormDateField({ label, value, onChange, error, helperText, min, max, required, disabled }) {
  return (
    <TextField
      type="date"
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={required}
      disabled={disabled}
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      inputProps={{ min, max }}
    />
  );
}
